import React from 'react';

const Footer = () => {
  // Get the current year automatically
  const currentYear = new Date().getFullYear();

  const footerStyle = {
    textAlign: 'center',
    padding: '20px',
    marginTop: 'auto', // Pushes the footer to the bottom
    color: '#888',
    fontSize: '14px',
    borderTop: '1px solid #eee'
  };

  return (
    <footer style={footerStyle}>
      <p>&copy; {currentYear} 4xbiz.com. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;